import { IS_OFFLINE_ENABLED } from 'appConstants';

import { SET_OFFLINE_STATUS } from './actionTypes';
import type { IOfflineDataState } from './types';

export const initialState = {
  isOfflineEnabled: IS_OFFLINE_ENABLED,
  isOffline: !navigator.onLine && IS_OFFLINE_ENABLED,
  hasOfflineOrders: false,
};

export const reducer = (
  state: IOfflineDataState = initialState,
  action: { type: any; payload?: any },
): IOfflineDataState => {
  switch (action.type) {
    case SET_OFFLINE_STATUS:
      return { ...state, isOffline: action.payload };
    default:
      return state;
  }
};
